(function () {
  if (window.MHFreeGift) return;

  var PROP_KEY = '_auto_free_gift';
  var PROP_VALUE = '1';
  var SHIPPING_TYPE = 'tech_hidden_shipping';
  var inflight = null;
  var syncTimer = null;
  var checkoutBound = false;

  function config() {
    var cfg = window.MHFreeGiftConfig || {};
    var enabled = cfg.enabled;
    // New theme checkbox settings are often nil until saved — default ON.
    if (enabled === undefined || enabled === null || enabled === '') enabled = true;
    return {
      enabled: enabled === true || enabled === 'true' || enabled === 1 || enabled === '1',
      thresholdCents: Math.max(0, Number(cfg.thresholdCents) || 0),
      variantId: cfg.variantId ? Number(cfg.variantId) : null,
      productId: cfg.productId ? Number(cfg.productId) : null,
      discountCode: String(cfg.discountCode || 'FREEhamper').trim(),
      propertyKey: cfg.propertyKey || PROP_KEY,
      propertyValue: cfg.propertyValue || PROP_VALUE
    };
  }

  function isEnabled() {
    var cfg = config();
    return cfg.enabled && cfg.variantId && cfg.thresholdCents > 0;
  }

  function shopRoot() {
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  }

  function discountCode() {
    return config().discountCode || '';
  }

  function applyDiscountCode() {
    var code = discountCode();
    if (!code) return Promise.resolve(false);

    var discountUrl = shopRoot() + 'discount/' + encodeURIComponent(code);
    // Sets the discount cookie for this browser session.
    return fetch(discountUrl, { credentials: 'same-origin', redirect: 'follow' })
      .then(function () { return true; })
      .catch(function () { return false; });
  }

  function checkoutUrlWithDiscount(forceDiscount) {
    var url = shopRoot() + 'checkout';
    var code = discountCode();
    if (code && forceDiscount) {
      url += '?discount=' + encodeURIComponent(code);
    }
    return url;
  }

  function prepareCheckout() {
    return fetchCart().then(function (cart) {
      var hasGift = giftLines(cart).length > 0 || wantedQuantity(cart) > 0;
      if (!hasGift || !discountCode()) {
        return checkoutUrlWithDiscount(false);
      }
      return applyDiscountCode().then(function () {
        return checkoutUrlWithDiscount(true);
      });
    }).catch(function () {
      return checkoutUrlWithDiscount(!!discountCode());
    });
  }

  function maybeApplyDiscountForCart(cart) {
    if (!cart) return Promise.resolve(false);
    if (giftLines(cart).length > 0 || wantedQuantity(cart) > 0) {
      return applyDiscountCode();
    }
    return Promise.resolve(false);
  }

  function isShippingItem(item) {
    if (!item) return false;
    if (item.product_type === SHIPPING_TYPE) return true;
    if (item.handle && item.handle.indexOf('shipping-') === 0) return true;
    var props = item.properties || {};
    return !!(props._static_shipping);
  }

  function isGiftItem(item) {
    var cfg = config();
    if (!item) return false;
    if (cfg.variantId && Number(item.id) === cfg.variantId) return true;
    if (cfg.productId && Number(item.product_id) === cfg.productId) return true;
    var props = item.properties || {};
    return String(props[cfg.propertyKey] || '') === String(cfg.propertyValue);
  }

  function isAutoFreeGift(item) {
    if (!isGiftItem(item)) return false;
    var props = item.properties || {};
    var cfg = config();
    return String(props[cfg.propertyKey] || '') === String(cfg.propertyValue);
  }

  function qualifyingCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (isShippingItem(item)) return;
      if (isGiftItem(item)) return;
      total += Number(item.final_line_price) || 0;
    });
    return total;
  }

  function wantedQuantity(cart) {
    var cfg = config();
    if (!cfg.thresholdCents) return 0;
    return Math.floor(qualifyingCents(cart) / cfg.thresholdCents);
  }

  function giftLines(cart) {
    return (cart.items || []).filter(isGiftItem);
  }

  function giftLinesAreValid(cart, wanted) {
    var lines = giftLines(cart);
    if (wanted === 0) return lines.length === 0;
    if (lines.length !== 1) return false;
    var line = lines[0];
    if (Number(line.quantity) !== wanted) return false;
    return isAutoFreeGift(line);
  }

  function getSections() {
    var cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      return cartItems.getSectionsToRender().map(function (section) { return section.section; });
    }
    return [];
  }

  function postCart(url, payload) {
    return fetch(url, Object.assign(fetchConfig(), { body: JSON.stringify(payload) }))
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.errors || json.status === 422) {
            return Promise.reject(json);
          }
          return json;
        });
      });
  }

  function ensureSections(state) {
    if (state && state.sections) return Promise.resolve(state);
    return postCart(routes.cart_update_url, {
      sections: getSections(),
      sections_url: window.location.pathname
    });
  }

  function applyCartState(parsedState) {
    if (!parsedState) return;
    var cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (cartItems && parsedState.sections && typeof cartItems.renderSections === 'function') {
      cartItems.renderSections(parsedState, { patchLines: true });
    }
    var destManager = document.querySelector('cart-address-manager');
    if (destManager) {
      if (typeof destManager.updateOrderSummary === 'function') destManager.updateOrderSummary();
      if (typeof destManager.updateMobileBar === 'function') destManager.updateMobileBar();
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-free-gift' });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-free-gift' } }));
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  function removeGiftItems(cart, withSections) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (isGiftItem(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) {
      return Promise.resolve(cart);
    }
    var payload = { updates: updates };
    if (withSections) {
      payload.sections = getSections();
      payload.sections_url = window.location.pathname;
    }
    return postCart(routes.cart_update_url, payload);
  }

  function giftProperties() {
    var cfg = config();
    var properties = {};
    properties[cfg.propertyKey] = cfg.propertyValue;
    return properties;
  }

  function changeGiftLine(line, quantity) {
    return postCart(routes.cart_change_url, {
      id: line.key,
      quantity: quantity,
      properties: giftProperties(),
      sections: getSections(),
      sections_url: window.location.pathname
    });
  }

  function addGift(quantity) {
    var cfg = config();
    return postCart(routes.cart_add_url, {
      items: [{
        id: cfg.variantId,
        quantity: quantity,
        properties: giftProperties()
      }],
      sections: getSections(),
      sections_url: window.location.pathname
    });
  }

  function setGiftQuantity(cart, wanted, render) {
    var lines = giftLines(cart);

    if (wanted <= 0) {
      return removeGiftItems(cart, true).then(function (state) {
        return render ? ensureSections(state) : state;
      });
    }

    // Fast path: bump quantity on the existing auto-gift line (avoids inventory race on remove+add).
    if (lines.length === 1) {
      return changeGiftLine(lines[0], wanted).then(function (state) {
        return render ? ensureSections(state) : state;
      }).catch(function () {
        // Fallback if change fails (e.g. wrong variant / properties): remove all, then add.
        return removeGiftItems(cart, false).then(function () {
          return addGift(wanted);
        }).then(function (state) {
          return render ? ensureSections(state) : state;
        });
      });
    }

    return removeGiftItems(cart, false).then(function () {
      return addGift(wanted);
    }).then(function (state) {
      return render ? ensureSections(state) : state;
    });
  }

  function runSync(options) {
    options = options || {};
    if (!isEnabled()) {
      return Promise.resolve({ ok: true, skipped: true, reason: 'disabled' });
    }

    return fetchCart().then(function (cart) {
      var wanted = wantedQuantity(cart);
      var render = options.render !== false;

      if (giftLinesAreValid(cart, wanted)) {
        return maybeApplyDiscountForCart(cart).then(function () {
          return { ok: true, skipped: true, cart: cart, quantity: wanted };
        });
      }

      return setGiftQuantity(cart, wanted, render).then(function (state) {
        if (render) applyCartState(state);
        return fetchCart().then(function (nextCart) {
          if (!giftLinesAreValid(nextCart, wanted) && wanted > 0) {
            // One retry after race with other cart syncs (e.g. static shipping).
            return setGiftQuantity(nextCart, wanted, render).then(function (retryState) {
              if (render) applyCartState(retryState);
              return fetchCart().then(function (finalCart) {
                return maybeApplyDiscountForCart(finalCart).then(function () {
                  return { ok: true, cart: retryState, quantity: wanted, retried: true };
                });
              });
            });
          }
          return maybeApplyDiscountForCart(nextCart).then(function () {
            return { ok: true, cart: state, quantity: wanted };
          });
        });
      });
    }).catch(function () {
      return { ok: false, reason: 'request' };
    });
  }

  var queue = Promise.resolve();

  function enqueue(fn) {
    var task = queue.then(function () { return fn(); }, function () { return fn(); });
    queue = task.then(function () {}, function () {});
    return task;
  }

  function sync(options) {
    return enqueue(function () {
      var run = function () { return runSync(options); };
      inflight = inflight ? inflight.then(run, run) : run();
      var thisChain = inflight;
      inflight = thisChain.finally(function () {
        if (inflight === thisChain) inflight = null;
      });
      return thisChain;
    });
  }

  function scheduleSync() {
    if (!isEnabled()) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      sync({ render: true });
    }, 250);
  }

  function whenIdle() {
    clearTimeout(syncTimer);
    syncTimer = null;
    return enqueue(function () { return inflight || Promise.resolve(); });
  }

  function validateBeforeCheckout() {
    if (!isEnabled()) return Promise.resolve({ ok: true, skipped: true });
    return sync({ render: false, checkout: true }).then(function (result) {
      if (!result || result.ok === false) return result || { ok: false, reason: 'request' };

      return fetchCart().then(function (cart) {
        var wanted = wantedQuantity(cart);
        if (!giftLinesAreValid(cart, wanted)) {
          return { ok: false, reason: 'mismatch', cart: cart, quantity: wanted };
        }
        return maybeApplyDiscountForCart(cart).then(function () {
          return { ok: true, cart: cart, quantity: wanted };
        });
      });
    });
  }

  function bindCheckoutGuard() {
    if (checkoutBound) return;
    checkoutBound = true;

    function runCheckout(button) {
      if (button && button.dataset.mhFreeGiftCheckout === '1') return Promise.resolve();
      if (button) {
        button.dataset.mhFreeGiftCheckout = '1';
        button.setAttribute('disabled', 'disabled');
      }

      return validateBeforeCheckout()
        .then(function (result) {
          if (result && result.ok === false) throw result;
          return prepareCheckout();
        })
        .then(function (url) {
          window.location.assign(url || checkoutUrlWithDiscount(!!discountCode()));
        })
        .catch(function () {
          if (button) {
            button.removeAttribute('disabled');
            button.dataset.mhFreeGiftCheckout = '';
          }
        });
    }

    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest
        ? event.target.closest('button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, #checkout')
        : null;
      if (!button || button.disabled) return;
      if (button.closest('cart-address-manager')) return;
      if (!isEnabled()) return;

      event.preventDefault();
      event.stopPropagation();
      runCheckout(button);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      if (form.closest && form.closest('cart-address-manager')) return;
      if (!isEnabled()) return;
      var submitter = event.submitter;
      var isCheckout = (submitter && submitter.name === 'checkout') ||
        (form.querySelector('[name="checkout"]') && document.activeElement && document.activeElement.name === 'checkout');
      if (!isCheckout && !(submitter && (submitter.id === 'CartDrawer-Checkout' || submitter.id === 'checkout'))) return;
      if (submitter && submitter.dataset && submitter.dataset.mhFreeGiftCheckout === '1') return;

      event.preventDefault();
      event.stopPropagation();
      runCheckout(submitter);
    }, true);
  }

  document.addEventListener('cart:updated', function (event) {
    if (event && event.detail && event.detail.source === 'cart-free-gift') return;
    var manager = document.querySelector('cart-address-manager');
    if (manager && manager._checkingOut) return;
    scheduleSync();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cart-free-gift') return;
      var manager = document.querySelector('cart-address-manager');
      if (manager && manager._checkingOut) return;
      scheduleSync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCheckoutGuard();
      scheduleSync();
    });
  } else {
    bindCheckoutGuard();
    scheduleSync();
  }

  window.MHFreeGift = {
    sync: sync,
    scheduleSync: scheduleSync,
    whenIdle: whenIdle,
    enqueue: enqueue,
    validateBeforeCheckout: validateBeforeCheckout,
    prepareCheckout: prepareCheckout,
    applyDiscountCode: applyDiscountCode,
    isGiftItem: isGiftItem,
    qualifyingCents: qualifyingCents,
    wantedQuantity: wantedQuantity
  };
})();
